export default [
    {
        // [0]
        key: "business_name",
        label: app.$i18n.t("Business Name"),
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "document_type",
        label: app.$i18n.t("Document Type"),
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "document_number",
        label: app.$i18n.t("Document Number"),
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "delegate",
        label: app.$i18n.t("Delegate"),
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "phone",
        label: app.$i18n.t("Phone"),
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "cell_phone",
        label: app.$i18n.t("Cell Phone"),
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "email",
        label: app.$i18n.t("Email"),
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "status",
        label: app.$i18n.t("Status"),
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "address",
        label: app.$i18n.t("Address"),
        sortable: true,
        visible: true,
    },
    {
        // [4]
        key: "created_by",
        label: app.$i18n.t("Created By"),
        sortable: true,
        visible: true,
    },
    {
        // [13]
        key: "actions",
        label: app.$i18n.t("Actions"),
        visible: true,
        tdClass: "text-center",
        thClass: "text-center",
    },
]